module.exports = __webpack_public_path__ + "img/price-comparison-prevention.c7eb7ebf.png";